export default __webpack_public_path__ + "static/media/e2.3f5cb53d.svg";